import React from 'react';
import {
  CatalogFilterLayout,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListPicker,
  EntityListProvider,
} from '@backstage/plugin-catalog-react';
import { TechDocsPicker } from '@backstage/plugin-techdocs';
import { EntityListDocsTable } from '@backstage/plugin-techdocs';
import {
  FullPage,
  PageHeader,
  MaterialIcon,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

export const TechdocsHomePage = (): React.ReactElement => {
  return (
    <FullPage
      variant="card"
      HeaderComponent={() => (
        <PageHeader
          subtitle="Documentation"
          title="Tech Docs"
          icon={<MaterialIcon.menu_book />}
        />
      )}
    >
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <TechDocsPicker />
            <UserListPicker initialFilter="all" />
            <EntityOwnerPicker />
            <EntityTagPicker />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <EntityListDocsTable />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </FullPage>
  );
};
